import React from 'react';
import { PdfData } from '@/models';
import { imageSrc, styles } from './constants';

export const PdfTemplate: React.FC<PdfData & { children: React.ReactNode | React.ReactNode[] }> = ({
  mediaPlan,
  ...data
}): React.ReactElement => (
  <html lang="en">
    <head>
      <meta charSet="utf-8" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <title>Page Title</title>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
      <link
        href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700&display=swap"
        rel="stylesheet"
      />
      <style>{styles}</style>
    </head>
    <body className="table-document">
      <header>
        <div className="title-container">
          <img alt="" width="200" src={imageSrc} />
          <h1 className="title">Campaign Schedule</h1>
        </div>
        <ul className="contacts">
          <li>Skyrise</li>
          <li>100 Embankment</li>
          <li>Cathedral Approach</li>
          <li>Manchester</li>
          <li>M3 7FA</li>
        </ul>
      </header>
      <section className="sub-header">
        <div className="col">
          <div className="row">
            <div className="label">Order ID:</div>
            <div className="value">{mediaPlan.campaign.campaignId}</div>
          </div>
          <div className="row">
            <div className="label">Campaign:</div>
            <div className="value">{mediaPlan.campaign.name}</div>
          </div>
          <div className="row">
            <div className="label">Campaign dates:</div>
            <div className="value">{data.campaignDates}</div>
          </div>
        </div>
        <div className="col">
          <div className="row">
            <div className="label">Skyrise Contact:</div>
            {/* Guarded: a plan whose manager no longer resolves to a user is
                still a plan someone may export, and reading through an absent
                manager threw rather than leaving the field blank. */}
            <div className="value">{mediaPlan.manager?.email ?? ''}</div>
          </div>
          <div className="row">
            <div className="label">Client:</div>
            <div className="value">{mediaPlan.client.name}</div>
          </div>
          <div className="row">
            <div className="label">Advertiser:</div>
            {mediaPlan.campaign.advertiser && (
              <div className="value">{mediaPlan.campaign.advertiser.name}</div>
            )}
          </div>
        </div>
      </section>
      <section className="table-container">
        <table cellSpacing="0" cellPadding="0">
          <thead>
            <th>Channel</th>
            <th>Product</th>
            <th>Country</th>
            <th>Currency</th>
            <th>DSP</th>
            <th>Targeting Details</th>
            <th>Targeting KPI</th>
            <th>Format</th>
            <th>Buying Metric</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Rate</th>
            <th>Budget</th>
            <th>Impressions</th>
            {data.ctr && <th>Est. Clicks</th>}
            {data.vtr && <th>Est. Views</th>}
            {data.ltr && <th>Est. Listens</th>}
          </thead>
          <tbody>{React.Children.toArray(data.children)}</tbody>
        </table>
        {data.addFooter && (
          <div className="summary">
            <div className="col">
              {data.discount && (
                <>
                  <div className="row">
                    <div className="label">Sub Total</div>
                    <div className="value">£{mediaPlan.totalBudget}</div>
                  </div>
                  <div className="row">
                    <div className="label">Discount (15%)</div>
                    <div className="value">£{data.discount}</div>
                  </div>
                </>
              )}
              <div className="row total-column">
                <div className="label">Total</div>
                <div className="value">£{data.budgetWithDiscount}</div>
              </div>
            </div>
          </div>
        )}
      </section>
      {data.addFooter && (
        <footer>
          <p>By signing this order I agree to the following</p>
          <div className="signatures">
            <div className="label">Signed on behalf of Skyrise</div>
            <div className="label">Signed on behalf of Organization Name</div>
            <div className="label">Date</div>
          </div>
        </footer>
      )}
    </body>
  </html>
);
